import React, { useMemo } from 'react'
import { Box, Option, Select } from '@mui/joy'
import { useTranslation } from 'react-i18next'

const RecipeSelector = ({ recipes, handleApplyRecipe, apiRef, columns = [], visibilityModel, setSettingsKey }) => {
    const { t } = useTranslation();

    const options = useMemo(() => {
        if (!recipes) return [];

        if (Array.isArray(recipes)) {
            return recipes
                .map((recipe, index) => {
                    if (Array.isArray(recipe)) {
                        return {
                            key: `recipe_${index + 1}`,
                            label: `${t('Recipe')} ${index + 1}`,
                            value: recipe,
                        };
                    }

                    if (recipe && Array.isArray(recipe.columns)) {
                        return {
                            key: recipe.key || recipe.name || `recipe_${index + 1}`,
                            label: recipe.label || recipe.name || `${t('Recipe')} ${index + 1}`,
                            value: recipe.columns,
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        }

        return Object.entries(recipes).map(([key, value]) => ({
            key,
            label: t(key),
            value: Array.isArray(value) ? value : [],
        }));
    }, [recipes, t]);

    const activeRecipeKey = useMemo(() => {
        if (!visibilityModel || options.length === 0) return null;

        const comparableColumns = (Array.isArray(columns) ? columns : [])
            .filter((column) => column?.field && !column.field.startsWith('__') && column.hideable !== false);

        if (comparableColumns.length === 0) return null;

        const comparableFieldSet = new Set(comparableColumns.map((column) => column.field));

        const activeRecipe = options.find((option) => {
            const recipeFieldSet = new Set(
                (Array.isArray(option.value) ? option.value : []).filter((field) => comparableFieldSet.has(field))
            );

            return comparableColumns.every((column) => {
                const isVisible = visibilityModel[column.field] !== false;
                return recipeFieldSet.has(column.field) ? isVisible : !isVisible;
            });
        });

        return activeRecipe?.key ?? null;
    }, [columns, options, visibilityModel]);

    if (options.length === 0) return null;

    return (
        <Box sx={{ minWidth: 180 }}>
            <Select
                value={activeRecipeKey}
                onChange={(e, recipeKey) => {
                    const selectedRecipe = options.find((option) => option.key === recipeKey);
                    handleApplyRecipe(selectedRecipe?.value, apiRef, setSettingsKey);
                }}
                variant="outlined"
                autoComplete="off"
                placeholder={t('Select a view')}
                className="form-element-field form-element-field-select"
            >
                {options.map((option) => (
                    <Option key={option.key} value={option.key}>{option.label}</Option>
                ))}
            </Select>
        </Box>
    )
}

export default RecipeSelector
